import TermsAndConditionsComponent from "../../../../components/partner/Settings/terms-and-conditions/terms-and-conditions";

export default function TermsAndConditions() {
  return <TermsAndConditionsComponent />;
}
